import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const InputOtpLazy = lazyLoader(
  () => import('./InputOtp' /* webpackChunkName: "input-otp" */),
);

const InputOtp = () => {
  return (
    <Suspense fallback={null}>
      <InputOtpLazy />
    </Suspense>
  );
};

export default InputOtp;
